module.exports = __webpack_public_path__ + "img/Spinagino.b6755ff7.jpg";